import { render, staticRenderFns } from "./contracts.vue?vue&type=template&id=bcdc62d2"
import script from "./contracts.vue?vue&type=script&lang=js"
export * from "./contracts.vue?vue&type=script&lang=js"
import style0 from "./contracts.vue?vue&type=style&index=0&id=bcdc62d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports